import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';



import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class Shedule35Service {
  //Inicio auth
  idEmpresa: string;
  idUsuario: string;
  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();
  // Fin auth

  // private ip = 'http://35.232.140.117:3800';
  constructor(
    private httpClient: HttpClient,
    // Inicio auth
    private http:HttpClient,
    private authService:AuthService
    // fin auth
  ) {
     // Inicio auth
      this.idUsuario = this.authService.getIdUsuario();
      let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
      this.idEmpresa = infoUsu.empresaId;
     // Fin auth
   }

  public registerDateBegin(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.RegistarFecha +this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Norma35/programarEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getAdvice(data){ // GET DE RECORDATORIOS
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.RegistrarRecordatorio+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Norma35/programarEncuesta/recordatorios/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getFechaLanzamiento35(data){
    console.log("Data fecha lanzamiento");
    console.log(data);
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getfecha35+this.getCompanyID(),data);
  }

  public registerDate(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postProgramarEnc+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public registerRecordatorio(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postProgramarEnc+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public registerCierre(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.postProgramarEnc+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getFechaLanzamiento(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.getFechaLanzamiento+this.getCompanyID(),data);
  }

  public getRecordatorios(data){
    console.log("Data fecha recodatorios");
    console.log(data);
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.shedule.getRecordatorios+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/recordatorios/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  private getCompanyID():string{
    const token = localStorage.getItem('companyID');
    return token;
  }
  ////////////////OBTIENE EL TOKEN DEL USUARIO EN LINEA
  private getToken():string{
    const token = localStorage.getItem('token');
    return token;
  }
  registrarEnc35(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.RegistarFecha + this.idEmpresa,data);
  }

  RegistrarRecordatorio(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.RegistarFecha + this.idEmpresa,data);
  }

  public getBanderas(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getBaderasEncuesta+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


}
